import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=7338d955&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"
import style0 from "./HomePage.vue?vue&type=style&index=0&id=7338d955&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7338d955",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7338d955')) {
      api.createRecord('7338d955', component.options)
    } else {
      api.reload('7338d955', component.options)
    }
    module.hot.accept("./HomePage.vue?vue&type=template&id=7338d955&scoped=true", function () {
      api.rerender('7338d955', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/App/HomePage.vue"
export default component.exports